import { SupportersResp } from "@/types/coins"
import { User } from "@/types/users"

export function getAvatars(
  supportersWithAvatars: SupportersResp | undefined,
  allSupporters: SupportersResp | undefined
): Partial<User>[] | undefined {
  const avatars = supportersWithAvatars?.supporters
    .map((s): Partial<User> => {
      return {
        avatar_url: s.avatarUrl,
        lowercase_wallet_address: s.walletAddress as `0x${string}`,
        id: s.userId,
      }
    })
    .filter((_, i) => i < 3)

  if (!!avatars && !!allSupporters && avatars.length < 3) {
    avatars.push(
      ...allSupporters.supporters
        // Filter out any duplicates.
        .filter(
          (s) =>
            !avatars.some((a) => a.lowercase_wallet_address === s.walletAddress)
        )
        .slice(0, 3 - avatars.length)
        .map((s): Partial<User> => {
          return {
            avatar_url: s.avatarUrl,
            lowercase_wallet_address: s.walletAddress as `0x${string}`,
            id: s.userId,
          }
        })
    )
  }

  return avatars
}
